import {
    ChangeDetectionStrategy,
    Component,
    effect,
    inject,
    input,
    output,
    signal,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { DrawerComponent } from '../../../../lib';
import { ProductsService } from '../../services';
import { GetProductsRequestPost, Product } from '../../common';

@Component({
    selector: 'ca-product-picker',
    templateUrl: './product-picker.component.html',
    styleUrl: './product-picker.component.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ProductsService]
})
export class ProductPickerComponent {
    languageCode = input.required<GetProductsRequestPost['languageCode']>();
    countryCode = input.required<GetProductsRequestPost['countryCode']>();
    buttonText = input<string>('PRODUCT_PICKER.BUTTON.SHOW_ALL');
    headerText = input<string>('PRODUCT_PICKER.TITLE');
    asCustomButton = input<boolean>(false);
    productType = input<Product['productType']>();
    allowedProductTypes = input<Product['productType'][]>();
    productName = input<string>();
    allowDifferentProductTypeSelection = input<boolean>(true);
    selected = output<Product[]>();
    selectedProductType = signal<Product['productType'] | undefined>(undefined);
    productsService = inject(ProductsService);

    selectedProducts: Product[] = [];

    @ViewChild('drawer', { static: true }) drawer!: DrawerComponent;
    @ViewChild('actionEl', { static: true }) actionEl!: TemplateRef<any>;
    @ViewChild('productImageEl', { static: true }) productImageEl!: TemplateRef<any>;
    @ViewChild('dataCellElement', { static: true }) dataCellElement!: TemplateRef<any>;

    setLocale = effect(() => {
        this.productsService.setLocale(this.languageCode(), this.countryCode());
    });

    readProducts(): void {
        this.productsService.readProducts();
    }

    onDrawerVisibleChange(): void {
        this.productsService.cancelPending();
    }

    onFilter(filters: { productName: string; productType: Product['productType'] }): void {
        this.selectedProductType.set(filters.productType);
        this.productsService.setKeyword(filters.productName);
        this.productsService.setProductType(filters.productType);
        this.productsService.readProducts();
    }

    onProductSelect(product: Product): void {
        const isSelected = this.selectedProducts.find(p => p.id === product.id);
        if (isSelected) {
            this.selectedProducts = this.selectedProducts.filter(p => p.id !== product.id);
            return;
        }
        this.selectedProducts = [product];
    }

    close(): void {
        this.drawer.close();
    }

    confirm(): void {
        this.selected.emit(this.selectedProducts);
        this.drawer.close();
    }
}
